<his-page>
	<router-outlet></router-outlet>
</his-page>